/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IError } from '../../../../../base/api';
import { SetFieldParams } from '../../../../../base/interfaces/params';

export interface Fields {
    email: string;
    password: string;
}

export interface LoginState {
    fields: Fields;
    errors: IError | null;
    shouldScrollToError: boolean;
}

const fieldsInitialState = {
    email: '',
    password: '',
};

const initialState: LoginState = {
    fields: fieldsInitialState,
    errors: null,
    shouldScrollToError: false,
};

export const loginSlice = createSlice({
    name: 'recruiter-app__login',
    initialState,
    reducers: {
        clearData: (state) => {
            state.fields = fieldsInitialState;
            state.errors = null;
            state.shouldScrollToError = false;
        },
        setField: (state, action: PayloadAction<SetFieldParams>) => {
            state.fields = {
                ...state.fields,
                [action.payload.id]: action.payload.value,
            };
            if (state.errors === null) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.payload.errorGroupName || action.payload.id]: removedError, ...errors } = state.errors;
            state.errors = errors;
        },
        setErrors: (state, action: PayloadAction<IError>) => {
            if (state.errors) {
                state.errors = {
                    ...state.errors,
                    ...action.payload,
                };
            } else {
                state.errors = action.payload;
            }
        },
        setShouldScrollToError: (state, action: PayloadAction<boolean>) => {
            state.shouldScrollToError = action.payload;
        },
        submitLogin: () => {},
    },
});

export const loginActions = loginSlice.actions;
export const loginReducer = loginSlice.reducer;
